/**
 * Component to render in application submissions tab at How to Nominate page DTA
 */
const SubmissionsSection = (): React.ReactElement => {
  return (
    <div
      className="mb-5 bg-gray-150 px-6 py-4 pb-5 font-public-sans"
      data-testid="submissions-section-component"
    >
      <p className="mb-8">Applications are now closed.</p>
    </div>
  );
};

export default SubmissionsSection;
